import React, { useEffect, useState } from "react";
import classes from "./databaseDefault.module.css";
import Sidebar from "../../components/ui/AppShell/Sidebar";
import { Box, Button, Flex, Modal, Pagination, rem, ScrollArea, Text, TextInput } from "@mantine/core";
import { IconCopyPlus, IconSearch } from "@tabler/icons-react";
import { useMediaQuery } from "@mantine/hooks";
import TableDatabase from "../../components/pages/database/TableDatabase";
import TableSkeleton from "../../components/ui/TableSkeleton";
import { getListDatabase } from "../../services/database";
import FormDatabase from "../../components/pages/database/FormDatabase";

const defaultParameter = {
  skip: 0,
  take: 10,
  keyword: "",
};

const labelTable = [
  {
    label: "No.",
    width: 30,
  },
  {
    label: "Nama Database",
    width: "auto",
  },
  {
    label: "Aplikasi",
    width: "auto",
  },
  {
    label: "Status",
    width: "auto",
  },
  {
    label: "Tgl Dibuat",
    width: "auto",
  },
  {
    label: "Action",
    width: 100,
  },
];

const DatabaseDefault = () => {
  const [params, setParams] = useState(defaultParameter);
  const [databaseDefaultList, setDatabaseDefaultList] = useState([]);
  const [count, setCount] = useState(0);
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 425px)");

  const handleGetDatabaseDefault = async () => {
    setLoading(true);
    try {
      const response = await getListDatabase(params);
      setDatabaseDefaultList(response.data);
      setCount(response.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetDatabaseDefault();
    // eslint-disable-next-line
  }, [params]);

  const handleSearchChange = (e) => {
    const params = {
      skip: 0,
      take: 10,
      keyword: e.target.value,
    };
    setParams(params);
  };

  const handleChangePage = (e) => {
    const params = {
      skip: (e - 1) * 10,
      take: 10,
      keyword: "",
    };
    setParams(params);
  };

  const onCloseModalForm = () => {
    setOpenModalForm(false);
    setDetailData(null);
  };

  const actions = {
    edit: (val) => {
      setOpenModalForm(true);
      setDetailData(val);
    },
  };

  const handleAction = (val, type) => {
    return actions[type](val);
  };

  return (
    <Sidebar>
      <Box>
        <Text className={classes.titlePage} mb={20}>
          Database Default Management
        </Text>

        <Box style={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", justifyContent: "space-between" }}>
          <Flex>
            <TextInput mr={8} leftSectionPointerEvents="none" leftSection=<IconSearch style={{ width: rem(16), height: rem(16) }} /> placeholder="Cari Database. . ." name="search" onChange={handleSearchChange} />
          </Flex>
          <Flex mt={isSmallScreen ? 10 : 0}>
            <Button fullWidth={isSmallScreen} leftSection={<IconCopyPlus size={14} />} color="#0572b9" onClick={() => setOpenModalForm(true)}>
              Tambah Database
            </Button>
          </Flex>
        </Box>
        <Box my={20}>{loading ? <TableSkeleton total={5} /> : <TableDatabase label={labelTable} data={databaseDefaultList} countData={params.skip} actionMethod={handleAction} />}</Box>
        <Flex justify="end">
          <Pagination onChange={handleChangePage} total={Math.ceil(count / params.take) || 0} color="#0572b9" radius="lg" />
        </Flex>
        <Modal
          opened={openModalForm}
          onClose={onCloseModalForm}
          centered
          closeOnClickOutside={false}
          size="lg"
          title={<Text fw="Bold">{detailData ? "Edit Database Default" : "Tambah Database Default"}</Text>}
          scrollAreaComponent={ScrollArea.Autosize}
          withCloseButton={false}
        >
          <FormDatabase dataDatabaseDefault={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetDatabaseDefault} />
        </Modal>
      </Box>
    </Sidebar>
  );
};

export default DatabaseDefault;
